// extracted by mini-css-extract-plugin
export var actionIcon = "_qd-0";